import axios from "axios";
import  config  from "../../config";
const apiurl = config.ADMIN_BASE_URL;

// ----------------------------Api service for get users------------------------

// export const getUsers = async (navigate, search, page, per_page) => {
//   const token = localStorage.getItem("cookies");
//   if (!token) {
//     navigate("/admin/login");
//     return;
//   }
//   try {
//     //users?search=nitish_kumar_0&page=1&per_page=100 // call this api for search
//     const response = await axios.get(`${apiurl}/users`, {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       params: { search, page, per_page },
//     });

//     return response.data.data.filter(
//       (user) => user.status == "1" || user.status == "3"
//     );
//     // return data.data.filter((user) => user.status == "1" || user.status == "3");
//   } catch (err) {
//     if (err.response) {
//       throw new Error(err.response.data.message || "Failed to fetch users.");
//     } else if (err.request) {
//       throw new Error("No response from server. Please check your connection.");
//     } else {
//       throw new Error("An unexpected error occurred. Please try again.");
//     }
//   }
// };



export const getUsers = async (navigate, search = '', page = 1, per_page = 10) => {
  console.log("search", search, page, per_page
  );
  const token = localStorage.getItem("cookies");
  if (!token) {
    navigate("/login");
    return;
  }

  try {
    const response = await axios.get(`${apiurl}/users`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        search,
        page,
        per_page
      },
    });

    // Process the API response to match our expected format
    return {
      users: response.data.data,
      pagination: response.data.pagination
    };
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message || "Failed to fetch users.");
    } else if (err.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};
// ----------------------------Api service for get user by id------------------------
export const getUserAllPost = async (userId, page) => {
  const token = localStorage.getItem("cookies");
  try {
    const url = `${apiurl}/users/${userId}/posts`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: { page: page },
    });
    console.log("All bios test:", response.data);
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(
        err.response.data.message || "Failed to fetch user posts."
      );
    } else if (err.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

// ----------------------------Api service for get user by id------------------------
export const getUserPostByStatus = async (userId, status, page) => {
  // console.log("userId", userId, status, page);
  const token = localStorage.getItem("cookies");
  // if status is 3 then call the  getUserAllPost api
  if (status === 3) {
    return getUserAllPost(userId, page);
  }

  try {
    const url = `${apiurl}/users/${userId}/posts/posts-by-status`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: { status, page },
    });
    console.log("All Posts Response:", response.data);
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error();
      // err.response.data.message || "Failed to fetch user posts."
    } else if (err.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

// ---------------------------------block and unblock the user  ------------------------
export const userAction = async (userId, status) => {
  console.log("userId", userId, status);
  const token = localStorage.getItem("cookies");
  // console.log("token", token);
  try {
    const response = await axios.post(
      `${apiurl}/users/${userId}/block`,
      { status },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log("response", response);

    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(
        err.response.data.message || "Failed to perform action on post."
      );
    } else if (err.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

// ------------------------------ get connection of user  (/user/{userId}/connections)----------------------------   )
export const getUserConnections = async (userId) => {
  const token = localStorage.getItem("cookies");
  try {
    const response = await axios.get(`${apiurl}/user/${userId}/connections`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message || "Failed to fetch connections.");
    } else if (err.request) {
      throw new Error("No response from server. Please check your connection.");
    } else {
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};




//POST : https://api.autovertest.com/api/v1/admin/newsletter
export const sendNewsletter = async (data) => {
  const token = localStorage.getItem("cookies");
  try {
    const response = await axios.post(`${apiurl}/newsletter`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
   return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
}


//GET : https://api.autovertest.com/api/v1/admin/newsletter
export const getNewsletterHistory = async (search = '', page, per_page = 10) => {
  console.log("search", search, page, per_page);
  const token = localStorage.getItem("cookies");
  try {
    const response = await axios.get(`${apiurl}/newsletter`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { search, page, per_page }, // Use per_page as per API
    });
    return response.data; // Returns { message, data, pagination }
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};